export var DELIVERY_METHOD_TRANSLATION = {
    delivery_type_step: {
        delivery_type: 'Define el tipo de entrega',
        select_option: 'Selecciona la mejor forma de entrega para tus ordenes',
        commission: 'De comisión',
        iva: '+ IVA',
        recommended: 'Recomendado',
        discountCode: {
            placeHolder: 'Escribe el código',
            invalidCode: 'Cupón no valido',
            failed: 'Error al procesar. Inténtalo más tarde.',
        },
        discount_coupon: 'Cupón de descuento',
        discount_applied: 'Descuento aplicado',
        discount_coupon_applied: 'Cupón de descuento aplicado!',
        do_you_have_refrence_code: '¿Tienes un código referido? Puedes aplicar abajo',
        'change-to-selected-plan': 'Consulta los cambios en el plan seleccionado',
        apply: 'Aplicar',
    },
    commercialPlans: {
        fullService: {
            title: 'Rappi entrega',
            benefits: {
                AR: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                BR: [
                    'Parceiro vende e a entrega será via entregadores independentes  cadastrados na  Rappi.',
                    '<b>Tarifas de</b> 3,5% sobre os pedidos.',
                    '<b>Repasse</b> quinzenal.',
                    '<b>Contrato:</b> Duração de {{periods}} meses e poderá  rescindir com aviso prévio  de 90 dias.',
                    '<b>O Parceiro deverá</b> Manter o cardápio atualizado com  preços iguais a outros canais de vendas, autorizando a Rappi proceder 10% de descontos.',
                ],
                CL: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                CO: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                CR: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                MX: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                EC: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                PE: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                UY: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
            },
            discounts: '<b>0% de tarifa</b> en los primeros {{days}} <br> días por el uso de la plataforma',
        },
        marketplace: {
            title: 'Entrega Propia',
            benefits: {
                AR: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                BR: [
                    'Parceiro vende na Rappi e realiza a entrega por conta própria.',
                    '<b>Tarifas de</b> 3,5% sobre os pedidos.',
                    '<b>Repasse</b> quinzenal.',
                    '<b>Contrato:</b> Duração de {{periods}} meses e poderá  rescindir  com aviso prévio  de 90 dias.',
                    '<b>O Parceiro deverá</b> Manter o cardápio atualizado com  preços iguais a outros canais de vendas, autorizando a Rappi proceder 10% de descontos.',
                ],
                CL: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                CO: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                CR: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                MX: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                EC: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                PE: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                UY: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
            },
            discounts: '<b>0% de tarifa</b> en los primeros {{days}} <br> días por el uso de la plataforma',
        },
    },
};
